exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4f382fca]:export{menu-bgc-oragne:#F2C46D}.lang-select[data-v-4f382fca]{font-size:15px !important;display:inline-block;font-family:\"Microsoft YaHei\", SimHei, Helvetica, Arial, sans-serif}.lang-select span[data-v-4f382fca]{font-weight:bold;cursor:pointer;color:#053C80}.lang-select span.active[data-v-4f382fca]{color:#fff}.lang-select span[data-v-4f382fca]:hover{color:#fff}\n", ""]);

// exports
